import gql from 'graphql-tag';

export const create4506CMutation = gql`
         mutation($applicationId: String, $approvalTaskId: String, $dwellingId: String, $applicationSgStatus: Int, $signer1: SignerInput!, $signer2: SignerInput!, $email: String, $envelopeId: String, $documentId: String, $approvalTaskItemKey: String, $attempt: Int,$returnUrl: String,$isBorrowerAssisted: Boolean!) {
           create4506C(applicationId: $applicationId, approvalTaskId: $approvalTaskId, dwellingId: $dwellingId, applicationSgStatus: $applicationSgStatus, signer1: $signer1, signer2: $signer2, email: $email, envelopeId: $envelopeId, documentId: $documentId, approvalTaskItemKey: $approvalTaskItemKey, attempt: $attempt,returnUrl: $returnUrl,isBorrowerAssisted:$isBorrowerAssisted) {
           status
           statusDescription
           approvalTaskItemId
           isBorrowerAssisted
           success
           message
           documentProcessorResponse {
               errorMessage
               envelopeId
               documentId
               signerDtos {
                 signerName
                 recipientId
                 clientId
                 viewUrl
                 recipientIdD365
                 taskItemId
               }
             }
           }
         }
       `;

export const get4506cViewUrls = gql`
         mutation($applicationId: String, $approvalTaskId: String, $dwellingId: String, $signer1: SignerInput!, $signer2: SignerInput!, $email: String, $envelopeId: String, $documentId: String,$returnUrl: String) {
           get4506cViewUrls(applicationId: $applicationId, approvalTaskId: $approvalTaskId, dwellingId: $dwellingId, signer1: $signer1, signer2: $signer2, email: $email, envelopeId: $envelopeId, documentId: $documentId,,returnUrl: $returnUrl) {
             documentProcessorResponse {
               errorMessage
               envelopeId
               documentId
               signerDtos {
                 signerName
                 recipientId
                 clientId
                 viewUrl
                 recipientIdD365
                 taskItemId
               }
             }
           }
         }
       `;
